import { number_from_currency } from './procurement_compliance_helpers';

function value_or_default(value, fallback_value) {
  const resolved_value = value || fallback_value;
  return resolved_value;
}

export function requisition_form_from_row(row) {
  const selected_supplier = row.supplier === '-' ? '' : value_or_default(row.supplier, '');
  const requisition_form = {
    requisition: row.requisition,
    department: row.dept,
    value: String(number_from_currency(row.value)),
    procurement_method: value_or_default(row.method, 'Single quote'),
    threshold_band: row.threshold,
    stage: value_or_default(row.stage, ''),
    selected_supplier,
    supplier_eligibility: row.eligibility.label,
    compliance_status: row.status.label,
    note: value_or_default(row.note, '')
  };
  return requisition_form;
}

export function bid_form_from_row(row) {
  const bid_form = {
    requisition: row.requisition,
    committee: value_or_default(row.committee, 'Bid Specification (BSC)'),
    chairperson: value_or_default(row.chairperson, ''),
    declarations: value_or_default(row.declarations?.label, ''),
    evaluation: value_or_default(row.evaluation, ''),
    recommendation: value_or_default(row.recommendation, ''),
    status: value_or_default(row.status?.label, 'In progress')
  };
  return bid_form;
}

export function award_form_from_row(row) {
  const approved_by = row.approved_by === '-' ? '' : value_or_default(row.approved_by, '');
  const award_form = {
    supplier: value_or_default(row.supplier, ''),
    requisition: value_or_default(row.for, ''),
    value: String(number_from_currency(row.value)),
    method: value_or_default(row.method, 'Single quote'),
    approved_by,
    date: value_or_default(row.date, ''),
    status: value_or_default(row.status?.label, 'Awarded')
  };
  return award_form;
}

export function deviation_form_from_row(row, source) {
  const type = value_or_default(row.type, source === 'emergency' ? 'Emergency' : 'Deviation');
  const deviation_form = {
    title: value_or_default(row.title, ''),
    type,
    value: String(number_from_currency(row.value)),
    justification: value_or_default(row.justification, ''),
    approved_by: value_or_default(row.approved_by, ''),
    date: value_or_default(row.date, ''),
    status: value_or_default(row.status?.label, 'Approved')
  };
  return deviation_form;
}

export function irregularity_form_from_row(item) {
  const detail = value_or_default(item.detail, value_or_default(item.meta, ''));
  const severity = value_or_default(item.severity, value_or_default(item.badge, 'Irregular'));
  const irregularity_form = {
    flag: value_or_default(item.title, ''),
    type: value_or_default(item.type, 'Split-order detection'),
    value: String(number_from_currency(item.value)),
    detail,
    severity,
    status: value_or_default(item.status, 'Open')
  };
  return irregularity_form;
}
